<template>
  <div id="app">
  
     <com-header :style="{backgroundColor:opacity}" v-if="$store.state.isShow"></com-header>
    <com-H5-Header v-else></com-H5-Header>
    <router-view/>
     <com-footer></com-footer>
     <com-float :show="flag" @gotop="gotop"></com-float>
  </div>
</template>

<script>
import comHeader from "./components/com-header";
import comFooter from "./components/com-footer";
import comFloat from "./components/com-float";
import comH5Header from "./components/com-h5-header";
export default {
  name: "App",
  components: {
    comHeader,
    comFooter,
    comFloat,
    comH5Header
  },
  data() {
    return {
      opacity: 0,
      flag: false,
      screenWidth: document.documentElement.clientWidth //屏幕宽度
      //  isShow:false
    };
  },
  created() {
    // console.log("isShow",isShow);

    var _this = this;
    window.onresize = function() {
      // 定义窗口大小变更通知事件
      _this.$store.state.screenWidth = document.documentElement.clientWidth; 
    };
    this.change(this.screenWidth);
  },

  computed: {
    listenShowPage() {
      return this.$store.state.screenWidth;
    }
  },
  watch: {
    listenShowPage: function(a, b) {
      //监听屏幕宽度变化
      this.change(b);
    }
  },
  methods: {
    change(val) {
      if (val > 750) {
        this.$store.commit("SET_ISSHOW", true);
      } else {
        this.$store.commit("SET_ISSHOW", false);
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      // 隐藏返回顶部图标
      if (scrollTop > document.getElementById("app").offsetHeight / 2) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      // 改变导航颜色值
      if (scrollTop / 400 > 1) {
        this.opacity = "rgba(45,46,56,1)";
      } else {
        this.opacity = "rgba(45,46,56," + scrollTop / 80 + ")";
      }
    },
    gotop() {
      document.getElementById("app").scrollIntoView();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  }
};
</script>
<style>
/* body {
    -webkit-text-size-adjust: 100% !important;
} */
/* body * { max-height: 999999px; }  */
* {
  -webkit-text-size-adjust: none;
}
html{
  font-size: 375Px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.public_main {
  min-height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue